<template>
    <v-layout class="d-flex justify-center align-center h-screen">
        <slot></slot>
    </v-layout>
</template>

<script setup>
import {useAuthStore} from "@/stores/authStore";
import {useNavigation} from "@/composables/globals";

const {navigateTo} = useNavigation()
const authStore = useAuthStore()
if (authStore.isAuthenticated()) {
    const {menus} = authStore
    if (menus) {
        if (Object.keys(menus).includes('dashboard')) {
            navigateTo('dashboard')
        } else {
            navigateTo('profile')
        }
    } else {
        navigateTo('dashboard')
    }
}
</script>
